import { ActionSheetContext, LgPadding, LoadingEmptyState, SmSpacing } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useContext } from 'react';
import essentialsIcon from '~shared/assets/images/essentials_nav_list_icon@2x.png';
import illustrationMedications from '~shared/assets/images/prescription@2x.png';
import { getCompanyName } from '~shared/config/getCompanyName';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { useAnalytics } from '~shared/hooks';
import { useFeatureDisablingMapping } from '~shared/hooks/useIsFeatureDisabledForCompany';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { MedicationsSectionNavigator } from './MedicationsSectionNavigator';
import { PharmacyInfoActionSheet } from '~web/features/profile/components/PharmacyInfoActionSheet';
import illustrationStethoscope from '~web/images/stethoscope@2x.png';

export const SendMedications = () => {
  const { navigate } = useNavigation();
  const { trackEvent } = useAnalytics();
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const { disabledFeatures, isLoading } = useFeatureDisablingMapping();
  const shouldDisableOTCForCompany = disabledFeatures.otc;
  const shouldDisableTransferPrescriptionForCompany = disabledFeatures.transfer_prescription;
  const shouldDisableAltoPharmacyInfoForCompany = disabledFeatures.alto_pharmacy_info;

  const navigateToEssentialsStore = () => {
    trackEvent({ event: EVENTS.ESSENTIALS__SHOP_ESSENTIALS_CARD_TAPPED });
    navigate('RouteEssentials', { search: `?origin=${ORIGIN_NAMES.HOMESCREEN}` });
  };

  const navigateToSendPrescriptionOptions = () => {
    navigate('RouteTransferOptions');
  };

  const openPharmacyInfoModal = () => {
    setActiveActionSheet(<PharmacyInfoActionSheet />);
  };

  if (isLoading) {
    return (
      <LgPadding>
        <LoadingEmptyState />
      </LgPadding>
    );
  }

  return (
    <>
      {shouldDisableOTCForCompany ? null : (
        <MedicationsSectionNavigator
          illustration={essentialsIcon}
          illustrationAlt="image of essential items"
          label="Shop Essentials"
          description="Browse over-the-counter products"
          onClick={navigateToEssentialsStore}
        />
      )}
      {shouldDisableTransferPrescriptionForCompany ? null : (
        <MedicationsSectionNavigator
          illustration={illustrationMedications}
          illustrationAlt={IMG_ALT_TEXTS.prescription}
          label={`Transfer to ${getCompanyName()}`}
          description="Transfer from another pharmacy"
          onClick={navigateToSendPrescriptionOptions}
        />
      )}
      {shouldDisableAltoPharmacyInfoForCompany ? null : (
        <MedicationsSectionNavigator
          illustration={illustrationStethoscope}
          illustrationAlt={IMG_ALT_TEXTS.stethoscope}
          label={`See ${getCompanyName()}'s pharmacy info`}
          description="Share it with your provider"
          onClick={openPharmacyInfoModal}
        />
      )}
      <SmSpacing />
    </>
  );
};
